import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpWalletQrisRequestPinCollectionResponse } from '../../../data/repository/fs-wallet-qris/http-fs-wallet-qris.collection';
import { UseCase } from '../../base/usecase';
import { FSWalletQrisRepository } from '../../repository/fs-wallet-qris.repository';
import { OtpRequestDTO } from './interface/otp-request.dto';

@Injectable({
  providedIn: 'root',
})
export class RequestPinUsecase
  implements
    UseCase<OtpRequestDTO, HttpWalletQrisRequestPinCollectionResponse>
{
  constructor(private readonly repository: FSWalletQrisRepository) {}

  execute(
    data: OtpRequestDTO
  ): Observable<HttpWalletQrisRequestPinCollectionResponse> {
    return this.repository.RequestPin(data);
  }
}
